export default __webpack_public_path__ + "static/media/default.97b01e7f.svg";